<script lang="ts">
  /** Optional minimum height so layout doesn't jump when remote loads */
  export let minHeight: string = "4rem";
</script>

<div
  class="flex items-center justify-center w-full bg-[#1b1e2e]/50 rounded-xl border border-white/10"
  style="min-height: {minHeight};"
  role="status"
  aria-label="Loading remote component"
>
  <div
    class="w-8 h-8 border-2 border-white/20 border-t-white rounded-full animate-spin"
  ></div>
</div>
